import React, { FC, useEffect, useState } from 'react';

import { Icon, IconSearch } from '../../../base/icons';

export interface FilterProps {
    onSearch?: () => void,
    onSubmit?: () => void,
    withSearchIcon?: boolean,
    keyword?: string
}
const Filter: FC<FilterProps> = ({ onSearch, onSubmit, withSearchIcon }) => {
    const [ valueKey, setValueKey ] = useState('');

    const handleChange = (value: string) => {
        if (value?.length > 100) {
            return;
        }
        onSearch(value);
        setValueKey(value);
    };

    return (
        <div className = { 'a-search' }>
            <input
                className = { 'a-search-input' }
                type = 'text'
                onChange = { e => handleChange(e.target.value) }
                placeholder = { 'Search' }
                value = { valueKey } />
            {withSearchIcon && <div
                className = { 'a-search-icon dis-flex ali-center' }
                onClick = { onSubmit }>
                <Icon src = { IconSearch } />
            </div>}

        </div>

    );

};

Filter.defaultProps = {
    onSearch: () => {},
    onSubmit: () => {},
    withSearchIcon: false,
    keyword: ''
};
export default Filter;
